const  axios = require('axios');

const axiosInstance = axios.create({
   baseURL: `${process.env.REACT_APP_API_ENDPOINT}/api/v1`
});
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = {
      Accept: 'application/json',
      'Content-Typ': 'application/json'
    };
    return config;
  },
  (error) => Promise.reject(error)
);
  

export const sendGet = (url = "", params) => axiosInstance.get(url, { params }).then((res) => res);
export const sendPost = (url = "", params, queryParams) => axiosInstance
    .post(url, params, { params: queryParams })
    .then((res) => res)
    .catch((err) =>err);
